const content = [
  "Hi, who just joined?",
  "Can you email that to everyone?",
  " _____, are you there?",
  "you're still sharing...",
  "I have to jump to another call",
  "(Sound of someone typing)",
  "(Loud, painful, echo)",
  "(Child or Animal noises)",
  "Hi, can you hear me?",
  "No, it's still loading",
  "Let's meet to discuss",
  "Can everyone go on mute?",
  "I'm sorry,I was on mute",
  "Can we take this offline?",
  "Can everyone see my screen?",
  "I think there's a lag",
  "Sorry, I was having connection issues",
  "can you repeat?",
  "Sorry, didn't catch that",
  "I'm sorry, you cut out there",
  "I have a hard stop at--",
  "I'll have to get back to you",
  "Hello? Hello?",
  "Happy to announce",
  "Next slide, please",
];
export default content;
